import { 
  OCR_SERVICE_URL, 
  ZENDESK_SERVICE_URL, 
  ENVIRONMENT, 
  API_TIMEOUT, 
  MAX_FILE_SIZE,
  SUPPORT_EMAIL,
  validateEnvironment
} from './constants';

export type Environment = 'development' | 'production' | 'staging';

export interface ApiConfig {
  ocrServiceUrl: string;
  zendeskServiceUrl: string;
  environment: string;
  timeout: number;
  maxFileSize: number;
  retries: number;
}

/**
 * Get API configuration based on environment variables
 */
export const getApiConfig = (): ApiConfig => {
  // Validate required environment variables
  validateEnvironment();
  
  const config: ApiConfig = {
    ocrServiceUrl: OCR_SERVICE_URL,
    zendeskServiceUrl: ZENDESK_SERVICE_URL,
    environment: ENVIRONMENT,
    timeout: API_TIMEOUT,
    maxFileSize: MAX_FILE_SIZE,
    retries: ENVIRONMENT === 'production' ? 2 : 3, // Fewer retries in production
  };

  return config;
};

export const config = getApiConfig();

// Validation constants based on API specification
export const VALIDATION_CONSTANTS = {
  MAX_FILE_SIZE: config.maxFileSize,
  MIN_FILE_SIZE: 1024, // 1KB minimum
  ALLOWED_FILE_TYPES: ['.pdf'],
  ALLOWED_MIME_TYPES: ['application/pdf'],
  CONFIDENCE_THRESHOLD: {
    HIGH: 0.8,
    MEDIUM: 0.6,
    LOW: 0.4,
  },
  DATE_URGENCY_DAYS: {
    URGENT: 3,
    WARNING: 7,
    ATTENTION: 14,
  },
} as const;

// API endpoints
export const API_ENDPOINTS = {
  PROCESS_NOTICE: '/process-notice',
  CREATE_TICKET: '/create-notice-ticket',
  HEALTH_OCR: '/health',
  HEALTH_ZENDESK: '/health',
} as const;

// Contact information (imported from constants)
export const CONTACT_INFO = {
  SUPPORT_EMAIL: SUPPORT_EMAIL,
  COMPANY_NAME: 'Diana HR',
} as const;

export default config;